import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";
import request from "@/lib/api/handler";
import {
  ICandidateObject,
  ICandidateStatus,
  IJobOpening,
} from "@/redux/features/candidateProfileSlice";

export interface CandidateOpportunityProfile {
  candidate: ICandidateObject;
  company: {
    name?: string;
  };
  jobOpening: IJobOpening;
  candidateStatus: ICandidateStatus;
}

export const useCandidateOpportunityProfileQuery = (candidateStatusId = "") => {
  const { getAccessTokenSilently } = useAuth0();

  const { isLoading, data, error } = useQuery({
    queryKey: QueryKeys.candidateOpportunityProfile(candidateStatusId),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    enabled: !!candidateStatusId,
    queryFn: async () => {
      const token = await getAccessTokenSilently();

      return request<CandidateOpportunityProfile>({
        method: "GET",
        path: `/api/jobOpening/candidateStatus/${candidateStatusId}`,
        token,
      });
    },
  });

  return {
    candidateOpportunityProfileLoading: isLoading,
    candidateOpportunityProfile: data ?? null,
    candidateOpportunityProfileError: error ?? null,
  };
};
